// transfers
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import WebbSpinner from "../webb/webb-spinner-sm";
import ListNoData from "../webb/list-nodata";

import { GetEventsList, GetEventsCount } from "../../services/srvc-events-realm";


export default function EventsListWWModule() {

  const asset = {usid: 'ww'}
  const [loading, setLoading] = useState(true);

  const [item, setItems] = useState(10); // rows per page
  const [rows, setRows] = useState(0); // total rows
  const [cntr, setCounter] = useState(1); // current page counter
  const [live, setLive] = useState(false); // live stream

  const [data, setData] = useState([]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        
        setRows ((await GetEventsCount()).data)
        
      }
      fetchData()
    } else {}
  },[asset.usid]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        
        setLoading(true);
        
        setData ((await GetEventsList(({
          data: {item: item, cntr: cntr},
          user: asset.usid
        }))).data)
        
        setLoading(false);
      }
      fetchData()
    } else {}
  },[asset.usid, cntr, item]);


  const handleItem = items => {
    setItems(items)
  }


  const handleCounter = counter => {
    setCounter(counter)
  }


  if (loading){ return ( <> <div className="text-center"><WebbSpinner /></div> </> ) }
  if (!data || data.length === 0) { return ( <> <ListNoData/> </> ) }

  return (
  <>
    {console.log(data)}
    <div className="container">
  
    <div className="row row-cols-2 row-cols-md-4 g-4">
        {data && data.map((item, i) => (
          <div className="col" key={i}>
            
              <div className="card h-100 border-none">
              <Link to={`/e/${item.enid}`}>
              <div className="">
                <img src={item.link} className="img-fluid w-100 rounded-wd shadow" alt="..."></img>
              </div>
              </Link>
              <div className="card-body m-0">
                <p className='mb-2'>{item.stts}</p>
                <h5 className="fw-bold lead text-color-main text-md">{item.name}</h5>
                <p className='mb-2 text-wd'>{item.memo}</p>
              </div>
            </div>
            
            
            

          </div>
        ))}
        </div>

    </div>

  </>
  )
}